export const colors = [
  {
    name: "Alpine White",
    color: "#FFFFFE",
    icon: (
      <svg
        className="w-10 max-w-full"
        viewBox="0 0 46 46"
        style={{ fillRule: "evenodd", clipRule: "evenodd" }}
      >
        <g transform="matrix(1,0,0,1,-19.4384,-172.438)">
          <g id="Color-Chip">
            <circle
              id="Color-Chip-Large-Alpine-White"
              cx="42"
              cy="195"
              r="20.5"
              style={{
                fill: "white",
                stroke: "rgb(189,189,189)",
                strokeWidth: "1px",
              }}
            />
          </g>
        </g>
      </svg>
    ),
  },
  {
    name: "Sky Blue",
    color: "#7AD9ED",
    icon: (
      <svg
        className="w-10  max-w-full"
        width="100%"
        height="100%"
        viewBox="0 0 46 46"
        style={{ fillRule: "evenodd", clipRule: "evenodd" }}
      >
        <g transform="matrix(1,0,0,1,-19.4384,-232.938)">
          <g id="Color-Chip_2">
            <circle
              id="Color-Chip-Large-Sky-Blue"
              cx="42"
              cy="255.5"
              r="20.5"
              style={{
                fill: "url(#_LinearSkyBlue)",
                stroke: "rgb(189,189,189)",
                strokeWidth: "1px",
              }}
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="_LinearSkyBlue"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(2.57176e-15,42,-42,2.57176e-15,21,234.5)"
          >
            <stop offset="0" style={{ stopColor: "white", stopOpacity: "1" }} />
            <stop
              offset="1"
              style={{ stopColor: "rgb(0,182,221)", stopOpacity: "1" }}
            />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    name: "Cobalt Blue",
    color: "#3AA4E6",
    icon: (
      <svg
        className="w-10  max-w-full"
        width="100%"
        height="100%"
        viewBox="0 0 46 46"
        style={{ fillRule: "evenodd", clipRule: "evenodd" }}
      >
        <g transform="matrix(1,0,0,1,-19.4384,-293.438)">
          <g id="Color-Chip_3">
            <circle
              id="Color-Chip-Large-Cobalt-Blue"
              cx="42"
              cy="316"
              r="20.5"
              style={{
                fill: "url(#_RadialCobaltBlue)",
                stroke: "rgb(189,189,189)",
                strokeWidth: "1px",
              }}
            />
          </g>
        </g>
        <defs>
          <radialGradient
            id="_RadialCobaltBlue"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(-1.13177e-14,29.5612,-29.5612,-1.13177e-14,42,307.439)"
          >
            <stop
              offset="0"
              style={{ stopColor: "rgb(82,187,235)", stopOpacity: "1" }}
            />
            <stop
              offset="1"
              style={{ stopColor: "rgb(4,111,219)", stopOpacity: "1" }}
            />
          </radialGradient>
        </defs>
      </svg>
    ),
  },
  {
    name: "Caribbean Blue",
    color: "#3998CE",
    icon: (
      <svg
        className="w-10  max-w-full"
        width="100%"
        height="100%"
        viewBox="0 0 46 46"
        style={{ fillRule: "evenodd", clipRule: "evenodd" }}
      >
        <g transform="matrix(1,0,0,1,-19.4384,-353.938)">
          <g id="Color-Chip_4">
            <circle
              id="Color-Chip-Large-Caribbean-Blue"
              cx="42"
              cy="376.5"
              r="20.5"
              style={{
                fill: "url(#_LinearCaribbeanBlue)",
                stroke: "rgb(189,189,189)",
                strokeWidth: "1px",
              }}
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="_LinearCaribbeanBlue"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1.77764e-15,-29.031,29.031,1.77764e-15,56.5156,392.346)"
          >
            <stop
              offset="0"
              style={{ stopColor: "rgb(2,89,189)", stopOpacity: "1" }}
            />
            <stop
              offset="1"
              style={{ stopColor: "rgb(117,221,225)", stopOpacity: "1" }}
            />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    name: "Spring Green",
    color: "#04BB65",
    icon: (
      <svg
        className="w-10  max-w-full"
        width="100%"
        height="100%"
        viewBox="0 0 46 46"
        style={{ fillRule: "evenodd", clipRule: "evenodd" }}
      >
        <g transform="matrix(1,0,0,1,-19.4384,-414.438)">
          <g id="Color-Chip_5">
            <circle
              id="Color-Chip-Large-Spring-Green"
              cx="42"
              cy="437"
              r="20.5"
              style={{
                fill: "url(#_LinearSpringGreen)",
                stroke: "rgb(189,189,189)",
                strokeWidth: "1px",
              }}
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="_LinearSpringGreen"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(2.54549e-15,41.571,-41.571,2.54549e-15,21.2147,416)"
          >
            <stop
              offset="0"
              style={{ stopColor: "rgb(6,222,157)", stopOpacity: "1" }}
            />
            <stop
              offset="1"
              style={{ stopColor: "rgb(2,154,48)", stopOpacity: "1" }}
            />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    name: "Emerald Green",
    color: "#307848",
    icon: (
      <svg
        className="w-10  max-w-full"
        width="100%"
        height="100%"
        viewBox="0 0 46 46"
        style={{ fillRule: "evenodd", clipRule: "evenodd" }}
      >
        <g transform="matrix(1,0,0,1,-19.4384,-474.938)">
          <g id="Color-Chip_6">
            <circle
              id="Color-Chip-Large-Emerald-Green"
              cx="42"
              cy="497.5"
              r="20.5"
              style={{
                fill: "url(#_LinearEmeraldGreen)",
                stroke: "rgb(189,189,189)",
                strokeWidth: "1px",
              }}
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="_LinearEmeraldGreen"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(2.57176e-15,42,-42,2.57176e-15,21,476.5)"
          >
            <stop
              offset="0"
              style={{ stopColor: "rgb(10,241,251)", stopOpacity: "1" }}
            />
            <stop
              offset="1"
              style={{ stopColor: "rgb(6,111,49)", stopOpacity: "1" }}
            />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    name: "Emerald Rose",
    color: "#F6AA67",
    icon: (
      <svg
        className="w-10  max-w-full"
        width="100%"
        height="100%"
        viewBox="0 0 46 46"
        style={{ fillRule: "evenodd", clipRule: "evenodd" }}
      >
        <g transform="matrix(1,0,0,1,-19.4384,-535.438)">
          <g id="Color-Chip_7">
            <circle
              id="Color-Chip-Large-Emerald-Rose"
              cx="42"
              cy="558"
              r="20.5"
              style={{
                fill: "url(#_LinearEmeraldRose)",
                stroke: "rgb(189,189,189)",
                strokeWidth: "1px",
              }}
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="_LinearEmeraldRose"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1.96054e-15,32.018,-32.018,1.96054e-15,25.9909,544.389)"
          >
            <stop
              offset="0"
              style={{ stopColor: "rgb(250,183,175)", stopOpacity: "1" }}
            />
            <stop
              offset="1"
              style={{ stopColor: "rgb(12,69,36)", stopOpacity: "1" }}
            />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    name: "Ruby Red",
    color: "#FF0000",
    icon: (
      <svg
        className="w-10  max-w-full"
        width="100%"
        height="100%"
        viewBox="0 0 46 46"
        style={{ fillRule: "evenodd", clipRule: "evenodd" }}
      >
        <g transform="matrix(1,0,0,1,-19.4384,-595.938)">
          <g id="Color-Chip_8">
            <circle
              id="Color-Chip-Large-Ruby-Red"
              cx="42"
              cy="618.5"
              r="20.5"
              style={{
                fill: "rgb(255,0,0)",
                stroke: "rgb(189,189,189)",
                strokeWidth: "1px",
              }}
            />
          </g>
        </g>
      </svg>
    ),
  },
  {
    name: "Magenta",
    color: "#EE00EE",
    icon: (
      <svg
        className="w-10  max-w-full"
        width="100%"
        height="100%"
        viewBox="0 0 46 46"
        style={{ fillRule: "evenodd", clipRule: "evenodd" }}
      >
        <g transform="matrix(1,0,0,1,-19.4384,-656.438)">
          <g id="Color-Chip_9">
            <circle
              id="Color-Chip-Large-Magenta"
              cx="42"
              cy="679"
              r="20.5"
              style={{
                fill: "url(#_LinearMagenta)",
                stroke: "rgb(189,189,189)",
                strokeWidth: "1px",
              }}
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="_LinearMagenta"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(2.57176e-15,42,-42,2.57176e-15,21,658)"
          >
            <stop
              offset="0"
              style={{ stopColor: "rgb(255,5,255)", stopOpacity: "1" }}
            />
            <stop
              offset="0.42"
              style={{ stopColor: "rgb(255,0,255)", stopOpacity: "1" }}
            />
            <stop
              offset="1"
              style={{ stopColor: "rgb(167,0,167)", stopOpacity: "1" }}
            />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    name: "Violet",
    color: "#E168E1",
    icon: (
      <svg
        className="w-10  max-w-full"
        width="100%"
        height="100%"
        viewBox="0 0 46 46"
        style={{ fillRule: "evenodd", clipRule: "evenodd" }}
      >
        <g transform="matrix(1,0,0,1,-19.4384,-716.938)">
          <g id="Color-Chip_10">
            <circle
              id="Color-Chip-Large-Violet"
              cx="42"
              cy="739.5"
              r="20.5"
              style={{
                fill: "url(#_LinearViolet)",
                stroke: "rgb(189,189,189)",
                strokeWidth: "1px",
              }}
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="_LinearViolet"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1.75951e-15,28.735,-28.735,1.75951e-15,27.6324,731.121)"
          >
            <stop
              offset="0"
              style={{ stopColor: "rgb(238,130,238)", stopOpacity: "1" }}
            />
            <stop
              offset="1"
              style={{ stopColor: "rgb(198,50,198)", stopOpacity: "1" }}
            />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
];

export const colorShows = [
  {
    id: "slow-color-splash",
    name: "Slow Color Splash",
    colors: ["#7A40E2", "#25A9EC", "#133ECD", "#F54BEA"],
    timing: 1000,
    icon: (
      <svg
        className="w-10  max-w-full"
        width="100%"
        height="100%"
        viewBox="0 0 46 46"
        style={{ fillRule: "evenodd", clipRule: "evenodd" }}
      >
        <g transform="matrix(1,0,0,1,-19.4384,-817.438)">
          <g id="Color-Chip_12">
            <circle
              id="Color-Chip-Large-Color-Splash"
              cx="42"
              cy="840"
              r="20.5"
              style={{
                fill: "url(#_SlowColorSplash)",
                stroke: "rgb(189,189,189)",
                strokeWidth: "1px",
              }}
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="_SlowColorSplash"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(-39.8515,4.8804e-15,-4.8804e-15,-39.8515,63,856.703)"
          >
            <stop
              offset="0"
              style={{ stopColor: "#7A40E2", stopOpacity: "1" }}
            />
            <stop
              offset="0.31"
              style={{ stopColor: "#25A9EC", stopOpacity: "1" }}
            />
            <stop
              offset="0.63"
              style={{ stopColor: "#133ECD", stopOpacity: "1" }}
            />
            <stop
              offset="1"
              style={{ stopColor: "#F54BEA", stopOpacity: "1" }}
            />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    id: "fast-color-splash",
    name: "Fast Color Splash",
    colors: ["#7A40E2", "#25A9EC", "#133ECD", "#F54BEA"],
    timing: 800,
    icon: (
      <svg
        className="w-10  max-w-full"
        width="100%"
        height="100%"
        viewBox="0 0 46 46"
        style={{ fillRule: "evenodd", clipRule: "evenodd" }}
      >
        <g transform="matrix(1,0,0,1,-19.4384,-817.438)">
          <g id="Color-Chip_12">
            <circle
              id="Color-Chip-Large-Color-Splash"
              cx="42"
              cy="840"
              r="20.5"
              style={{
                fill: "url(#_FastColorSplash)",
                stroke: "rgb(189,189,189)",
                strokeWidth: "1px",
              }}
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="_FastColorSplash"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(-39.8515,4.8804e-15,-4.8804e-15,-39.8515,63,856.703)"
          >
            <stop
              offset="0"
              style={{ stopColor: "#7A40E2", stopOpacity: "1" }}
            />
            <stop
              offset="0.31"
              style={{ stopColor: "#25A9EC", stopOpacity: "1" }}
            />
            <stop
              offset="0.63"
              style={{ stopColor: "#133ECD", stopOpacity: "1" }}
            />
            <stop
              offset="1"
              style={{ stopColor: "#F54BEA", stopOpacity: "1" }}
            />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    id: "america-the-beautiful",
    name: "America the Beautiful",
    colors: ["#EC0F0F", "#FFFFFE", "#2434C6"],
    timing: 1000,
    icon: (
      <svg
        className="w-10  max-w-full"
        width="100%"
        height="100%"
        viewBox="0 0 46 46"
        style={{ fillRule: "evenodd", clipRule: "evenodd" }}
      >
        <g transform="matrix(1,0,0,1,-19.4384,-938.438)">
          <g id="Color-Chip_14">
            <circle
              id="Color-Chip-Large-America-the-Beautiful"
              cx="42"
              cy="961"
              r="20.5"
              style={{
                fill: "url(#_AmericaTheBeautiful)",
                stroke: "rgb(189,189,189)",
                strokeWidth: "1px",
              }}
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="_AmericaTheBeautiful"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(42.42,0,0,42.42,21.1083,982.105)"
          >
            <stop
              offset="0"
              style={{ stopColor: "#EC0F0F", stopOpacity: "1" }}
            />
            <stop
              offset="0.4"
              style={{ stopColor: "#FFFFFF", stopOpacity: "1" }}
            />
            <stop
              offset="0.59"
              style={{ stopColor: "#FFFFFF", stopOpacity: "1" }}
            />
            <stop
              offset="1"
              style={{ stopColor: "#2434C6", stopOpacity: "1" }}
            />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    id: "fat-tuesday",
    name: "Fat Tuesday",
    colors: [
      "#52E240",
      "#E5CDF0",
      "#DB4BD0",
      "#4C48C4",
      "#18B82B",
      "#1DB92F",
      "#E8E8EE",
      "#E76FE4",
      "#9A4BF5",
    ],
    timing: 1000,
    icon: (
      <svg
        className="w-10  max-w-full"
        width="100%"
        height="100%"
        viewBox="0 0 46 46"
        style={{ fillRule: "evenodd", clipRule: "evenodd" }}
      >
        <g transform="matrix(1,0,0,1,-19.4384,-998.938)">
          <g id="Color-Chip_15">
            <circle
              id="Color-Chip-Large-Fat-Tuesday"
              cx="42"
              cy="1021.5"
              r="20.5"
              style={{
                fill: "url(#_FatTuesday)",
                stroke: "rgb(189,189,189)",
                strokeWidth: "1px",
              }}
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="_FatTuesday"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(-40.885,5.00697e-15,-5.00697e-15,-40.885,63,1040.27)"
          >
            <stop
              offset="0"
              style={{ stopColor: "#52E240", stopOpacity: "1" }}
            />
            <stop
              offset="0.13"
              style={{ stopColor: "#E5CDF0", stopOpacity: 1 }}
            />
            <stop
              offset="0.24"
              style={{ stopColor: "#DB4BD0", stopOpacity: "1" }}
            />
            <stop
              offset="0.42"
              style={{ stopColor: "#4C48C4", stopOpacity: "1" }}
            />
            <stop
              offset="0.61"
              style={{ stopColor: "#18B82B", stopOpacity: "1" }}
            />
            <stop
              offset="0.61"
              style={{ stopColor: "#1DB92F", stopOpacity: "1" }}
            />
            <stop
              offset="0.78"
              style={{ stopColor: "#E8E8EE", stopOpacity: "1" }}
            />
            <stop
              offset="0.86"
              style={{ stopColor: "#E76FE4", stopOpacity: "1" }}
            />
            <stop
              offset="1"
              style={{ stopColor: "#9A4BF5", stopOpacity: "1" }}
            />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    id: "disco-tech",
    name: "Disco Tech",
    colors: [
      "#EB7107",
      "#0BFF00",
      "#23BE49",
      "#DBF1E9",
      "#18DAF4",
      "#5C5DD5",
      "#F54B96",
    ],
    timing: 1000,
    icon: (
      <svg
        className="w-10 max-w-full"
        width="100%"
        height="100%"
        viewBox="0 0 46 46"
        style={{ fillRule: "evenodd", clipRule: "evenodd" }}
      >
        <g transform="matrix(1,0,0,1,-19.4384,-1059.44)">
          <g id="Color-Chip_16">
            <circle
              id="Color-Chip-Large-Disco-Tech"
              cx="42"
              cy="1082"
              r="20.5"
              style={{
                fill: "url(#_DiscoTech)",
                stroke: "rgb(189,189,189)",
                strokeWidth: "1px",
              }}
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="_DiscoTech"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(-40.2387,4.92782e-15,-4.92782e-15,-40.2387,63,1100.77)"
          >
            <stop
              offset="0"
              style={{ stopColor: "#EB7107", stopOpacity: "1" }}
            />
            <stop
              offset="0.2"
              style={{ stopColor: "#0BFF00", stopOpacity: "1" }}
            />
            <stop
              offset="0.3"
              style={{ stopColor: "#23BE49", stopOpacity: "1" }}
            />
            <stop
              offset="0.45"
              style={{ stopColor: "#DBF1E9", stopOpacity: "1" }}
            />
            <stop
              offset="0.6"
              style={{ stopColor: "#18DAF4", stopOpacity: "1" }}
            />
            <stop
              offset="0.78"
              style={{ stopColor: "#5C5DD5", stopOpacity: "1" }}
            />
            <stop
              offset="1"
              style={{ stopColor: "#F54B96", stopOpacity: "1" }}
            />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
];

export function getColorForCode(colorCode: string) {
  let color = colors.find(
    (c) => c.color.toLowerCase() === colorCode.toLowerCase()
  );
  if (!color) {
    color = {
      name: "Custom Color",
      color: colorCode,
      icon: (
        <svg
          className="w-10 max-w-full"
          viewBox="0 0 46 46"
          style={{ fillRule: "evenodd", clipRule: "evenodd" }}
        >
          <g transform="matrix(1,0,0,1,-19.4384,-172.438)">
            <g id="Color-Chip">
              <circle
                id="Color-Chip-Large-Alpine-White"
                cx="42"
                cy="195"
                r="20.5"
                style={{
                  fill: colorCode,
                  stroke: "rgb(189,189,189)",
                  strokeWidth: "1px",
                }}
              />
            </g>
          </g>
        </svg>
      ),
    };
  }
  return color;
}
